// @flow

import { freeze } from "icepick";
import {
    CLEAR_BLOGS,
    FETCH_BLOGS_SUCCESS,
    FETCH_BLOGS_ERROR,
    FETCH_BLOG_SUCCESS,
    FETCH_BLOG_ERROR,
    FETCH_BLOG_IMAGES_SUCCESS,
    FETCH_BLOG_IMAGES_ERROR,
    SHOW_BLOG,
    HIDE_BLOG,
    SHOW_PHOTO,
    PREVIOUS_PHOTO,
    NEXT_PHOTO,
    HIDE_PHOTO,
    SEARCH
} from "./actions";

import { getOriginal } from "../../utils/image";
import type { BlogsState } from "./types";

export const getShowBlog = state => {
    if (state.all === null || state.showBlogId === null) {
        return null;
    }
    for (let i = 0; i < state.all.length; i += 1) {
        if (state.all[i].id === state.showBlogId) {
            return state.all[i];
        }
    }
    return null;
};

export const getShowPhoto = state => {
    if (state.photos === null || state.photos.length === 0 || state.showPhotoIndex === null) {
        return null;
    }
    return state.photos[state.showPhotoIndex];
};

const preloadNextPhotos = (photos, index) => {
    let nextPhoto = index === photos.length - 1 ? 0 : index + 1;
    const preload = new Image();
    preload.src = getOriginal(photos[nextPhoto].url);
    nextPhoto = nextPhoto === photos.length - 1 ? 0 : nextPhoto + 1;
    preload.src = getOriginal(photos[nextPhoto].url);
};

const initialState: BlogsState = freeze({
    all: null,
    showBlogId: null,
    photos: [],
    showPhotoIndex: null,
    searchResults: []
});

export default (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case CLEAR_BLOGS:
            return freeze({
                ...state,
                all: null
            });
        case FETCH_BLOGS_SUCCESS:
            return freeze({
                ...state,
                all: payload
            });
        case FETCH_BLOG_SUCCESS:
            if (state.all !== null && payload.length === 1) {
                const newAll = [];
                const blog = payload[0];
                for (let i = 0; i < state.all.length; i += 1) {
                    if (state.all[i].id === blog.id) {
                        newAll.push({ ...state.all[i], text: blog.text });
                    } else {
                        newAll.push(state.all[i]);
                    }
                }
                const newState = { ...state, all: newAll };
                return freeze(newState);
            }
            return state;
        case FETCH_BLOG_IMAGES_SUCCESS:
            if (state.all !== null) {
                const newAll = [];
                for (let i = 0; i < state.all.length; i += 1) {
                    if (state.all[i].id === payload.blogId) {
                        const blog = { ...state.all[i], images: payload.images };
                        newAll.push(blog);
                    } else {
                        newAll.push(state.all[i]);
                    }
                }
                const newState = { ...state, all: newAll };
                return freeze(newState);
            }
            return state;
        case FETCH_BLOGS_ERROR:
        case FETCH_BLOG_ERROR:
        case FETCH_BLOG_IMAGES_ERROR:
            return freeze({
                ...state,
                hasErrors: true
            });
        case SHOW_BLOG:
            return freeze({
                ...state,
                showBlogId: payload.id
            });
        case HIDE_BLOG:
            return freeze({
                ...state,
                showBlogId: null
            });
        case SHOW_PHOTO:
            preloadNextPhotos(payload.images, payload.index);
            return freeze({
                ...state,
                photos: payload.images,
                showPhotoIndex: payload.index
            });
        case PREVIOUS_PHOTO:
            return freeze({
                ...state,
                showPhotoIndex:
                    state.showPhotoIndex === 0 ? state.photos.length - 1 : state.showPhotoIndex - 1
            });
        case NEXT_PHOTO:
            const nextPhoto =
                state.showPhotoIndex === state.photos.length - 1 ? 0 : state.showPhotoIndex + 1;
            preloadNextPhotos(state.photos, nextPhoto);
            return freeze({
                ...state,
                showPhotoIndex: nextPhoto
            });
        case HIDE_PHOTO:
            return freeze({
                ...state,
                photos: null,
                showPhotoIndex: null
            });
        case SEARCH:
            let searchResults = [];
            if (payload.length > 0 && state.all) {
                const searchTerm = payload.toLowerCase();
                searchResults = state.all.filter(blog => blog.searchText.indexOf(searchTerm) >= 0);
            }
            return freeze({
                ...state,
                searchResults
            });

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/state/blogs/reducer.js